var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSafari = function SvgLogoSafari(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 212 52"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo-safari_svg__a",
    width: 31,
    height: 22,
    x: 2,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.665 18.663c-.324.138-1.42.63-1.713.8-4.227 2.369-14.64 14.83-14.655 16.861v.138c.2 1.078 17.694 2.37 22.43.878.324-.108 1.435-.57 1.759-.708a9.85 9.85 0 0 0 5.924-9.015c0-1.308-.263-2.631-.818-3.908-1.62-3.677-5.245-5.877-9.024-5.877a9.8 9.8 0 0 0-3.919.815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-safari_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-safari_svg__b)",
    d: "M32.44 17.847H2.298v21H32.44z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-safari_svg__c",
    width: 25,
    height: 37,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.934 3.63A11.6 11.6 0 0 0 1.496 7.4c-.154.385-.694 1.754-.802 2.154C.216 11.23 0 14.139 0 17.446c0 7.246.972 16.415 2.083 18.693.123.246.231.384.354.461 2.206 1.739 16.985-13.108 20.178-18.185.417-.661.772-1.415 1.08-2.415.417-1.385.633-2.77.633-4.139 0-4.784-2.592-9.107-7.343-11.03A12 12 0 0 0 13.175 0h-.618C9.317 0 6.202 1.323 3.95 3.646"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-safari_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-safari_svg__d)",
    d: "M10.047-11.958-18.938 22.49 14.27 50.278 43.254 15.83z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-safari_svg__f",
    width: 15,
    height: 24,
    x: 2,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.551,
    cy: 11.852,
    fill: "url(#logo-safari_svg__e)",
    rx: 6.551,
    ry: 11.852,
    transform: "matrix(.96054 .28359 -.28097 .9581 6.475 3.389)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-safari_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B18567",
    d: "M14.73 6.456c-4.048 2.892-7.875 14.419-9.283 19.82l2.251 2.985L18.58 18.966z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-safari_svg__h",
    width: 19,
    height: 13,
    x: 11,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.338,
    cy: 9.163,
    fill: "url(#logo-safari_svg__g)",
    rx: 5.338,
    ry: 9.163,
    transform: "matrix(.43806 .8633 -.91406 .4638 26.579 19.44)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-safari_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B28669",
    d: "M29.306 25.86c-3.897-.78-12.666 3.248-16.564 5.36l-.487 2.922 11.936.73z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E2E27",
    fillRule: "evenodd",
    d: "M172.783 20.599v.3h3.818v3.368h-3.818V37.05h-3.48V24.267h-2.451v-3.369h2.451v-.318c0-4.36 2.451-6.887 7.298-6.55v3.369c-2.452-.225-3.818.71-3.818 3.2m-43.72 11.322 3.2-1.872c.805 2.284 2.545 3.818 5.613 3.818s4.192-1.328 4.192-2.975c0-2.003-1.778-2.677-5.127-3.706-3.518-1.067-6.942-2.358-6.942-6.625s3.461-6.532 7.26-6.532 6.455 1.965 7.878 4.978l-3.125 1.816c-.805-1.816-2.227-3.163-4.753-3.163-2.171 0-3.555 1.104-3.555 2.807s1.253 2.49 4.547 3.519l.12.038c3.703 1.185 7.402 2.368 7.402 6.811 0 4.136-3.294 6.644-8.009 6.644-4.453 0-7.522-2.19-8.719-5.558zm-71.597-1.328c0 3.744-3.031 6.457-6.773 6.457H41V14.442h8.982c3.648 0 6.624 2.639 6.624 6.27 0 1.965-.88 3.593-2.302 4.622 1.909 1.011 3.162 2.845 3.162 5.26M44.705 17.943v5.951h5.258c1.646 0 2.9-1.291 2.9-2.975s-1.254-2.976-2.9-2.976zm9.038 12.464c0-1.778-1.329-3.163-3.07-3.163h-5.968v6.326h5.969c1.74 0 3.069-1.385 3.069-3.163m14.538-9.771v3.761c-2.302-.168-4.977.899-4.977 4.53v8.14h-3.48v-16.15h3.48v2.713c.973-2.19 2.937-2.994 4.977-2.994m17.792 16.434V20.92h-3.48v2.301c-1.235-1.684-3.125-2.714-5.651-2.714-4.397 0-8.046 3.706-8.046 8.497s3.648 8.497 8.046 8.497c2.526 0 4.416-1.048 5.65-2.751v2.32zm-8.589-13.25c2.92 0 5.109 2.171 5.109 5.166 0 2.994-2.19 5.165-5.109 5.165s-5.108-2.171-5.108-5.165 2.19-5.166 5.108-5.166m26.78-2.902L97.959 37.07h-4.023L87.63 20.917h3.817l4.51 12.278 4.49-12.278zm8.534-.43c-4.716 0-8.533 3.686-8.533 8.496 0 4.791 3.78 8.497 8.533 8.497s8.532-3.687 8.532-8.497-3.817-8.497-8.532-8.497m0 3.387c2.844 0 5.033 2.17 5.033 5.11 0 2.937-2.189 5.108-5.033 5.108s-5.034-2.17-5.034-5.109 2.19-5.11 5.034-5.11m51.926 13.196V20.917h-3.481v2.302c-1.235-1.684-3.125-2.714-5.651-2.714-4.397 0-8.046 3.706-8.046 8.497s3.649 8.497 8.046 8.497c2.526 0 4.416-1.048 5.651-2.751v2.32zm-8.608-13.25c2.919 0 5.109 2.17 5.109 5.165s-2.19 5.165-5.109 5.165-5.108-2.171-5.108-5.165 2.189-5.166 5.108-5.166m37.664 13.25V20.917h-3.48v2.302c-1.235-1.684-3.125-2.714-5.651-2.714-4.397 0-8.046 3.706-8.046 8.497s3.649 8.497 8.046 8.497c2.526 0 4.416-1.048 5.651-2.751v2.32zm-8.589-13.25c2.919 0 5.109 2.17 5.109 5.165s-2.19 5.165-5.109 5.165-5.108-2.171-5.108-5.165 2.189-5.166 5.108-5.166m20.47-3.185v3.761c-2.302-.168-4.978.899-4.978 4.53v8.14h-3.48v-16.15h3.48v2.713c.973-2.19 2.938-2.994 4.978-2.994m3.743-6.606a2.233 2.233 0 0 0-2.227 2.227c0 1.198 1.011 2.227 2.227 2.227a2.245 2.245 0 0 0 2.227-2.227 2.245 2.245 0 0 0-2.227-2.227m1.74 23.039V20.916h-3.48v16.152z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-safari_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 11.8524 -6.55142 0 6.551 11.852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-safari_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 9.16268 -5.33758 0 5.338 9.163)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-safari_svg__b",
    x1: 3.554,
    x2: 33.683,
    y1: 29.098,
    y2: 29.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#C39A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B18466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C3A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-safari_svg__d",
    x1: -2.87,
    x2: 21.11,
    y1: 34.816,
    y2: 6.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B68A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E7C3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C3A5"
  })))));
};
export default SvgLogoSafari;